
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbLgpd extends AppService {
  abstract getAllLgpd(filter: AppFilter): Observable<any>;
  abstract salvarLgpd(entity);
  abstract salvarLgpdAceite(entity): Promise<any>;
  abstract getLgpd(id);
  abstract deleteLgpd(id);
}